var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 463.902 463.902",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.722 80.25c4.478 2.52 34.62 17.082 49.182 24.094.057 5.652.182 15.426.374 15.592 1.605 13.996 4.36 29.545 5.158 33.936-1.324.734-8.129 5.184-8.129 19.025l.019.229c-.01.363-.019.729-.019 1.105 2.929 38.471 18.229 21.891 21.384 38.742 5.248 28.018 30.056 48.289 45.498 55.287 8.925 4.043 18.11 6.105 27.763 6.303 9.653-.197 18.838-2.26 27.763-6.303 15.442-6.998 40.25-27.27 45.498-55.287 3.155-16.852 18.455-.271 21.385-38.742 0-.377-.01-.742-.02-1.105l.02-.229c0-13.842-6.807-18.291-8.13-19.025.799-4.391 3.554-19.939 5.158-33.936.191-.166.317-9.939.374-15.592a6830.797 6830.797 0 0 0 31.256-15.139v37.189c-2.934 1.732-4.997 4.789-4.997 8.434 0 3.227 1.638 5.961 4.025 7.768 0 0-4.244 23.855-5.616 30.871-1.372 7.014 24.201 5.607 23.05 0-1.15-5.609-5.613-30.871-5.613-30.871 2.388-1.807 4.025-4.541 4.025-7.768 0-3.646-2.054-6.701-4.986-8.434V84.346c3.937-1.953 6.867-3.438 8.037-4.096 3.169-1.783 4.875-4.064 4.515-6.434.433-2.471-1.354-5.127-6.149-7.475C337.324 49.589 250.076 6.892 241.449 2.777 237.685.982 234.587.189 231.952 0c-2.635.189-5.733.982-9.497 2.777-8.627 4.115-95.875 46.813-130.097 63.564-4.797 2.348-6.583 5.004-6.149 7.475-.362 2.37 1.345 4.651 4.513 6.434zM348.104 320.885c-16.101-5.805-44.125-22.541-48.927-25.123a8.389 8.389 0 0 0-4.229-1.145 8.418 8.418 0 0 0-7.619 4.838c-13.275 22.223-37.886 86.846-55.058 88.045-.105-.008-.213-.029-.319-.041-.106.012-.214.033-.319.041-17.172-1.199-41.783-65.822-55.058-88.045a8.419 8.419 0 0 0-7.619-4.838 8.392 8.392 0 0 0-4.23 1.145c-4.801 2.582-32.826 19.318-48.926 25.123-54.042 19.486-78.348 39.359-78.348 52.91v90.107h389v-90.107c-.001-13.551-24.306-33.424-78.348-52.91z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.3acf6892947d869a8cc5fa59a9ebf438.svg";
export { ForwardRef as ReactComponent };